
export async function shareFromURL(url, filename, mimeType) {
  const res = await fetch(url);
  const blob = await res.blob();
  const file = new File([blob], filename || "file", {
    type: mimeType || blob.type || "application/octet-stream",
  });
  if (navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({ files: [file] });
    } catch {
    }
  }
}

export async function shareCurrent({ photoURL, videoURL, shareMime }) {
  if (photoURL) {
    return shareFromURL(photoURL, "photo.jpg", "image/jpeg");
  }
  if (videoURL) {
    const isMp4 = shareMime === "video/mp4";
    return shareFromURL(videoURL, isMp4 ? "recording.mp4" : "recording.webm", shareMime);
  }
}
